import React from 'react';
import { MenuItem } from 'react-bootstrap';

import NavBarLink from './NavBarLink';
import { can, permActions } from 'permissions';
import withUserTopNav from 'decorators/withUserTopNav';

let NavBarUser = ({ user, loggedInUser }) => {
  if (!user) {
    return null;
  }

  const showNewAddress = !user.address || user.address.length === 0;
  const links = [
    { to: `/users/${user.id}/view`, label: 'View Account' },
    {
      to: `/users/${user.id}/edit`,
      label: 'Edit Account',
      permission: can(loggedInUser, permActions.EDIT_USER_PROFILE, {
        user,
        loggedInUser,
      }),
    },
    {
      to: `/users/${user.id}/credits`,
      label: 'View Credits',
      permission: can(loggedInUser, permActions.VIEW_USER_CREDIT),
    },
    {
      to: `/users/${user.id}/logs`,
      label: 'View Logs',
      permission: can(loggedInUser, permActions.VIEW_USER_LOGS),
    },
    {
      to: `/users/${user.id}/payment-methods`,
      label: 'Payment Methods',
      permission: can(loggedInUser, permActions.VIEW_PAYMENT_METHODS),
    },
    {
      to: `/users/${user.id}/new-address`,
      label: 'New Address',
      condition: showNewAddress,
      permission: can(loggedInUser, permActions.CREATE_ADDRESS, {
        loggedInUser,
        userId: user.id,
      }),
    },
    {
      to: `/users/${user.id}/rolling-payments`,
      label: 'Rolling Payments',
      permission: can(loggedInUser, permActions.VIEW_USER_ROLLING_PAYMENTS),
    },
  ];

  return (
    <React.Fragment>
      <MenuItem divider />
      <MenuItem disabled>
        <b>User ID: {user.id}</b>
        <br />
        <b>
          {user.first_name} {user.last_name}
        </b>
      </MenuItem>
      {links.map((link) => (
        <NavBarLink key={link.to} {...link} />
      ))}
    </React.Fragment>
  );
};

export default withUserTopNav(NavBarUser);
